if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this._lb = { images: [], index: 0, zoom: 1, x: 0, y: 0, ready: false, json: [] };
      }

      _setup() {
        const s = this._lb;
        if (s.ready) return;
        s.ready = true;

        try {
          s.json = JSON.parse(this.querySelector('[data-lightbox-data]').textContent) || [];
        } catch (e) {
          s.json = [];
        }

        this._img = this.querySelector('[data-lightbox-img]');
        this._stage = this.querySelector('[data-lightbox-stage]');
        this._counter = this.querySelector('[data-lightbox-counter]');
        this._range = this.querySelector('[data-lightbox-zoom]');
        this._prev = this.querySelector('.giw-lightbox__nav--prev');
        this._next = this.querySelector('.giw-lightbox__nav--next');

        this._prev.addEventListener('click', (e) => { e.stopPropagation(); this._go(-1); });
        this._next.addEventListener('click', (e) => { e.stopPropagation(); this._go(1); });
        this._range.addEventListener('input', () => this._setZoom(parseFloat(this._range.value)));

        this.addEventListener('keydown', (e) => {
          if (e.target === this._range) return;
          if (e.key === 'ArrowLeft') this._go(-1);
          else if (e.key === 'ArrowRight') this._go(1);
        });

        this._bindGestures();
      }

      show(opener) {
        this._setup();
        super.show(opener);
        this._collect(opener);
      }

      // Build the image list from the on-page gallery's currently-shown slides (already filtered
      // to the selected variant). Falls back to the full product image list if no gallery is found.
      _collect(opener) {
        const s = this._lb;
        let start = 0;

        const gallery = (opener && opener.closest('media-gallery')) || document.querySelector('media-gallery');
        let slides = [];
        if (gallery) {
          slides = Array.prototype.slice
            .call(gallery.querySelectorAll('.product__media-item:not(.product__media-item--full)'))
            .filter((li) => li.querySelector('img'));
        }

        if (slides.length) {
          s.images = slides.map((li) => {
            const img = li.querySelector('img');
            const raw = img.getAttribute('src') || img.currentSrc || '';
            // Lightbox is fullscreen + zoomable, so request a high-res render regardless of the
            // (possibly small, mobile-optimized) on-page src: bump the Shopify width param to 2048.
            let hi = raw.replace(/([?&]width=)\d+/i, '$12048');
            if (hi === raw && raw) hi += (raw.indexOf('?') >= 0 ? '&' : '?') + 'width=2048';
            return { src: hi, alt: img.getAttribute('alt') || '' };
          });
          const startSlide = opener && opener.closest('.product__media-item');
          const idx = startSlide ? slides.indexOf(startSlide) : -1;
          start = idx < 0 ? 0 : idx;
        } else {
          s.images = s.json.map((im) => ({ src: im.src, alt: im.alt }));
          const id = opener && opener.getAttribute('data-media-id');
          const i = s.json.findIndex((im) => String(im.id) === String(id));
          start = i < 0 ? 0 : i;
        }

        const single = s.images.length <= 1;
        this._prev.style.display = single ? 'none' : '';
        this._next.style.display = single ? 'none' : '';

        this._render(start);
      }

      _render(i) {
        const s = this._lb;
        if (!s.images.length) return;
        s.index = (i + s.images.length) % s.images.length;
        const im = s.images[s.index];
        this._img.src = im.src;
        this._img.alt = im.alt || '';
        this._resetZoom();
        if (this._counter) this._counter.textContent = s.index + 1 + ' / ' + s.images.length;
      }

      _go(dir) {
        this._render(this._lb.index + dir);
      }

      _setZoom(z) {
        const s = this._lb;
        s.zoom = Math.max(1, Math.min(4, z));
        if (s.zoom === 1) {
          s.x = 0;
          s.y = 0;
        }
        this._apply();
        this._stage.classList.toggle('is-zoomed', s.zoom > 1);
        if (this._range) this._range.value = s.zoom;
      }

      _resetZoom() {
        const s = this._lb;
        s.zoom = 1;
        s.x = 0;
        s.y = 0;
        if (this._range) this._range.value = 1;
        this._apply();
        this._stage.classList.remove('is-zoomed');
      }

      _apply() {
        const s = this._lb;
        this._img.style.transform = 'translate(' + s.x + 'px,' + s.y + 'px) scale(' + s.zoom + ')';
      }

      _bindGestures() {
        const s = this._lb;
        let down = false;
        let sx = 0;
        let sy = 0;
        let ox = 0;
        let oy = 0;
        let moved = false;

        const start = (x, y) => {
          down = true;
          moved = false;
          sx = x;
          sy = y;
          ox = s.x;
          oy = s.y;
        };
        const move = (x, y, ev) => {
          if (!down) return;
          if (s.zoom > 1) {
            s.x = ox + (x - sx);
            s.y = oy + (y - sy);
            this._apply();
            moved = true;
            if (ev && ev.cancelable) ev.preventDefault();
          } else if (Math.abs(x - sx) > 8) {
            moved = true;
          }
        };
        const end = (x, target) => {
          if (!down) return;
          down = false;
          if (s.zoom === 1) {
            const dx = x - sx;
            if (Math.abs(dx) > 50) {
              this._go(dx < 0 ? 1 : -1);
              return;
            }
            if (!moved && target === this._stage) this.hide();
          }
        };

        this._stage.addEventListener('mousedown', (e) => { e.preventDefault(); start(e.clientX, e.clientY); });
        window.addEventListener('mousemove', (e) => move(e.clientX, e.clientY, e));
        window.addEventListener('mouseup', (e) => { if (down) end(e.clientX, e.target); });

        this._stage.addEventListener('touchstart', (e) => { const t = e.touches[0]; start(t.clientX, t.clientY); }, { passive: true });
        this._stage.addEventListener('touchmove', (e) => { const t = e.touches[0]; move(t.clientX, t.clientY, e); }, { passive: false });
        this._stage.addEventListener('touchend', (e) => { const t = e.changedTouches[0]; end(t.clientX, e.target); });

        this._stage.addEventListener('dblclick', (e) => {
          e.preventDefault();
          this._setZoom(s.zoom > 1 ? 1 : 2.5);
        });
      }
    }
  );
}